/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCartItemDomainAddResponseFromDiscriminatorValue, serializeWebhusetOrderApiFeaturesCartItemDomainAddRequest, serializeWebhusetOrderApiFeaturesCartItemDomainAddResponse, type WebhusetOrderApiFeaturesCartItemDomainAddRequest, type WebhusetOrderApiFeaturesCartItemDomainAddResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /cart/{cartId}/domain
 */
export interface DomainRequestBuilder extends BaseRequestBuilder<DomainRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCartItemDomainAddResponse>}
     */
     post(body: WebhusetOrderApiFeaturesCartItemDomainAddRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<WebhusetOrderApiFeaturesCartItemDomainAddResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: WebhusetOrderApiFeaturesCartItemDomainAddRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DomainRequestBuilderUriTemplate = "{+baseurl}/cart/{cartId}/domain";
/**
 * Metadata for all the requests in the request builder.
 */
export const DomainRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: DomainRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCartItemDomainAddResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeWebhusetOrderApiFeaturesCartItemDomainAddRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
